<div
  class="customer-view-actions-bar-shell d-flex flex-column shadow-sm rounded-2 border cursor-pointer"
>
  <ng-container
    *hasPermissionAny="[Permissions.RCS_Historic_All_Read, Permissions.RCS_Historic_Warnings_Read]"
  >
    <app-map-navigation-item>
      <span
        class="rb-ic rb-ic-import fs-2xl hover-effect p-2 rounded-2"
        data-cy="warning-archive-toggle"
        [class.sel-menu-item]="isDownloadVisible"
        (click)="toggleDownload.emit()"
        ngbTooltip="Download current warnings"
        tooltipClass="custom-tooltip"
        placement="start"
        [openDelay]="1000"
      >
      </span>
    </app-map-navigation-item>
  </ng-container>
</div>
